import _ from 'lodash'
import { Statsig } from 'statsig-react'
import { FeatureAvailability, featuresSchema } from '../../store/features/featuresSchema'
import { getFeatureNames } from '../../store/features/featuresSchemaService'
import { FeatureName } from '../../store/features/types'

export function getStatsigGates(): { [feature: string]: boolean } {
  const gates: { [name: string]: boolean } = {}

  for (const name of getFeatureNames()) {
    try {
      if (Statsig.checkGateWithExposureLoggingDisabled(name.toLowerCase())) {
        gates[name] = true
      }
    } catch (e) {}
  }

  return gates
}

export const UninitializedAvailabilitiesException = new Error(
  'You tried to access feature availabilites before they were initialized.\n' +
    'This is likeley because Statig was not initialized yet.\n' +
    'This rarely happens, because app rendering is mostly delayed until <StatsigProvider> init.\n' +
    'But it can sometimes happen for code that is not triggered from components (for example redux middleware, which runs on store creation)\n' +
    'In those cases, you need to manually prevent the call if statsig is uninitialized, and decide how the case should be handled.'
)

export const UninitializedValuesException = new Error(
  'You tried to access feature values before they were initialized.\n' +
    'This is likeley because Statig was not initialized yet.\n' +
    'This rarely happens, because app rendering is mostly delayed until <StatsigProvider> init.\n' +
    'But it can sometimes happen for code that is not triggered from components (for example redux middleware, which runs on store creation)\n' +
    'In those cases, you need to manually prevent the call if statsig is uninitialized, and decide how the case should be handled.'
)

const STATSIG_AVAILABILITIES: Record<FeatureAvailability, string> = {
  [FeatureAvailability.DEVELOPMENT]: 'development',
  [FeatureAvailability.PRIVATE_BETA]: 'private',
  [FeatureAvailability.PUBLIC_BETA]: 'public',
  [FeatureAvailability.HIDDEN]: 'hidden'
}

export const getFeatureAvailabilities = (): Record<FeatureName, FeatureAvailability> => {
  const statsigFeatures = Statsig.getConfig('beta_features')

  return _.mapValues(
    featuresSchema, // I <3 PRETTIER
    (definition, name): FeatureAvailability => {
      const statsigAvailability = Object.values(FeatureAvailability).find(availability => {
        return statsigFeatures
          .get<FeatureName[]>(STATSIG_AVAILABILITIES[availability], [])
          .map(name => name.toUpperCase())
          .includes(name)
      })

      return statsigAvailability || definition.defaultAvailability || FeatureAvailability.HIDDEN
    }
  )
}
